define("auth/templates/forgot-email", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tSU--container">
    {{! Card }}
    <div class="tSU--card">
      <h1 class="tSU--card__title u--m__b">{{t "authorization.forgot_email_page.form_title"}}</h1>
      <p class="u--text--md u--m__b__lg">{{t "authorization.forgot_email_page.form_subTitle"}}</p>
      {{! Form objects }}
      <form {{on "submit" (perform this.submitForgotEmail this.handle this.profileType)}}>
        <div class="tSU--card__formWrapper o--formWrapper--lg">
          <label>{{t "authorization.forgot_email_page.social_platform"}}</label>
          <PowerSelect
            @onChange={{this.setProfileType}}
            @options={{this.socialPlatformOptions}}
            @renderInPlace={{true}}
            @searchEnabled={{false}}
            @selected={{this.selectedOption}}
            as |option|
          >
            {{option.name}}
          </PowerSelect>
        </div>
        <div class="o--formWrapper--lg">
          <label for="username">{{t "authorization.forgot_email_page.enter_username"}}</label>
          <Input
            @type="string"
            @value={{this.handle}}
            class="o--form__input"
            id="username"
            placeholder={{t "authorization.forgot_email_page.username_placeholder"}}
            required="true"
            {{autofocus}}
          />
        </div>
        <div class="o--formSubmit">
          <Shared::Ui::Button
            @additional="block"
            @size="large"
            @text={{t "authorization.forgot_email_page.form_btn"}}
            type="submit"
          />
        </div>
      </form>
      {{! Log in Link }}
      <LinkTo @route="login" class="u--text--light u--text--underline u--text--sm u--block u--m__t">
        {{t "authorization.forgot_password.sign_in"}}
      </LinkTo>
      {{! Forgot Email }}
      <Shared::Link
        @href="https://help.later.com/hc/en-us/requests/new?&tf_14661951125015=source_forgot_email&tf_14233517033111=form_reason_account_login_issues"
        @text={{t "authorization.need_help"}}
        class="u--text--light u--text--underline u--text--sm u--block u--m__t__xs"
      />
    </div>
  </div>
  */
  {
    "id": "UmciPxAM",
    "block": "[[[10,0],[14,0,\"tSU--container\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n    \"],[10,\"h1\"],[14,0,\"tSU--card__title u--m__b\"],[12],[1,[28,[35,0],[\"authorization.forgot_email_page.form_title\"],null]],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md u--m__b__lg\"],[12],[1,[28,[35,0],[\"authorization.forgot_email_page.form_subTitle\"],null]],[13],[1,\"\\n\"],[1,\"    \"],[11,\"form\"],[4,[38,1],[\"submit\",[28,[37,2],[[30,0,[\"submitForgotEmail\"]],[30,0,[\"handle\"]],[30,0,[\"profileType\"]]],null]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"tSU--card__formWrapper o--formWrapper--lg\"],[12],[1,\"\\n        \"],[10,\"label\"],[12],[1,[28,[35,0],[\"authorization.forgot_email_page.social_platform\"],null]],[13],[1,\"\\n        \"],[8,[39,3],null,[[\"@onChange\",\"@options\",\"@renderInPlace\",\"@searchEnabled\",\"@selected\"],[[30,0,[\"setProfileType\"]],[30,0,[\"socialPlatformOptions\"]],true,false,[30,0,[\"selectedOption\"]]]],[[\"default\"],[[[[1,\"\\n          \"],[1,[30,1,[\"name\"]]],[1,\"\\n        \"]],[1]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,\"for\",\"username\"],[12],[1,[28,[35,0],[\"authorization.forgot_email_page.enter_username\"],null]],[13],[1,\"\\n        \"],[8,[39,4],[[24,0,\"o--form__input\"],[24,1,\"username\"],[16,\"placeholder\",[28,[37,0],[\"authorization.forgot_email_page.username_placeholder\"],null]],[24,\"required\",\"true\"],[4,[38,5],null,null]],[[\"@type\",\"@value\"],[\"string\",[30,0,[\"handle\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formSubmit\"],[12],[1,\"\\n        \"],[8,[39,6],[[24,4,\"submit\"]],[[\"@additional\",\"@size\",\"@text\"],[\"block\",\"large\",[28,[37,0],[\"authorization.forgot_email_page.form_btn\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[8,[39,7],[[24,0,\"u--text--light u--text--underline u--text--sm u--block u--m__t\"]],[[\"@route\"],[\"login\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,0],[\"authorization.forgot_password.sign_in\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"],[1,\"    \"],[8,[39,8],[[24,0,\"u--text--light u--text--underline u--text--sm u--block u--m__t__xs\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/requests/new?&tf_14661951125015=source_forgot_email&tf_14233517033111=form_reason_account_login_issues\",[28,[37,0],[\"authorization.need_help\"],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"option\"],false,[\"t\",\"on\",\"perform\",\"power-select\",\"input\",\"autofocus\",\"shared/ui/button\",\"link-to\",\"shared/link\"]]",
    "moduleName": "auth/templates/forgot-email.hbs",
    "isStrictMode": false
  });
});